import { AnimatePresence } from "framer-motion";
import { lazy, Suspense } from "react";
import {
  Link,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

const Admin = lazy(() => import("./pages/Admin"));
const Home = lazy(() => import("./pages/Home"));
const Laurita = lazy(() => import("./pages/Laurita"));
const Menu = lazy(() => import("./pages/Menu"));
const Navidad = lazy(() => import("./pages/Navidad"));

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <Suspense
      fallback={<p className="min-h-screen p-8 text-center">Cargando...</p>}
    >
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/navidad" element={<Navidad />} />
          <Route path="/laurita" element={<Laurita />} />
          <Route
            path="*"
            element={
              <main className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
                <h1 className="text-4xl font-bold">Página no encontrada</h1>
                <Link className="underline" to="/">
                  Volver al inicio
                </Link>
              </main>
            }
          />
        </Routes>
      </AnimatePresence>
    </Suspense>
  );
};

const App = () => (
  <Router>
    <AnimatedRoutes />
  </Router>
);

export default App;
